export const closeMode = (close) => close === true || close === undefined
    ? 2 /* LAST */
    : close === false
        ? 0 /* NEVER */
        : close;
